<template>
  <div>
    <div
      class="accordion-wrapper"
      v-for="(item, index) in sortedScreenPriceList"
      :key="item.id"
    >
      <div
        @click="
          toggleAccordion(
            item.applicationId,
            item.platformId,
            item.researchId,
            index
          )
        "
        :class="[
          'accordion-wrapper__row caption',
          activeIndex ? `active-${activeIndex}` : '',
        ]"
        v-if="
          item.applicationShortContent ||
          item.researchName ||
          item.applicationName
        "
      >
        <div class="accordion-title-wrapper" :class="{ active: activeIndex }">
          <div class="accordion-wrapper__row__cell">
            <span
              v-if="
                item.applicationShortContent != null &&
                item.applicationName != null
              "
              >{{ item.applicationName }}</span
            >
            <span v-if="item.researchName != null">{{
              item.researchName
            }}</span>
            <span
              v-if="
                item.applicationName != null &&
                item.applicationShortContent == null
              "
              >{{ item.applicationName }} {{ item.platformName }}</span
            >
          </div>

          <div
            class="accordion-wrapper__row__cell mh"
            :class="{ hidden: activeIndex !== index }"
          >
            Ücret
          </div>
          <div
            class="accordion-wrapper__row__cell mh"
            :class="{ hidden: activeIndex !== index }"
          >
            Gerekli Komisyon
          </div>
          <div
            class="accordion-wrapper__row__cell mh"
            :class="{ hidden: activeIndex !== index }"
          >
            Gerekli Fon / Bes Büyüklüğü
          </div>
          <base-icon
            class="collapse-icon"
            name="chevron-up"
            :class="{ active: activeIndex === index }"
          ></base-icon>
        </div>
      </div>
      <div class="accordion-content" v-show="activeIndex === index">
        <div
          class="accordion-wrapper__row"
          v-for="(items, innerIndex) in localFeatureScreenPricesList"
          :key="items.id"
        >
          <div class="accordion-wrapper__row__cell">
            <span class="inner-texts index">{{ innerIndex + 1 }}</span>
            <span class="inner-texts" v-if="items.market">
              {{ items.market.name }}
              <span
                class="inner-texts"
                v-if="
                  items.perspective &&
                  items.market.name != items.perspective.name
                "
                >{{ items.perspective.name }}</span
              >
              <span class="inner-texts" v-if="items.vendor">{{
                splitVendorNames(items.vendor.name)
              }}</span>
            </span>
            <span class="inner-texts" v-if="items.algorithm">{{
              items.algorithm.name
            }}</span>
            <span class="inner-texts" v-if="items.research">{{
              items.research.name
            }}</span>
            <span class="inner-texts" v-if="items.foreignIndice">{{
              items.foreignIndice.name
            }}</span>
          </div>
          <div class="accordion-wrapper__row__cell">
            <span v-if="items.price != 0">
              <span class="sm">Ücret</span>
              {{
                formatPriceNoDecimal(
                  items.price +
                    ((items.featureType == 3 || items.featureType == 4) &&
                    items.market.name.trim() !== "Osmanlı Pro -"
                      ? newScreenPrice[0].price
                      : 0)
                )
              }}
              {{ returnPriceTypeForScreenPrices(items.priceType) }}
            </span>
            <span v-else>
              <span class="sm">Ücret</span>
              0
              {{ returnPriceTypeForScreenPrices(items.priceType) }}
            </span>
          </div>
          <div class="accordion-wrapper__row__cell">
            <span v-if="items.commissionAmount != 0">
              <span class="sm">Gerekli Komisyon</span>
              {{ formatPriceNoDecimal(items.calculatedCommissionAmount) }}
              TL
            </span>
            <span v-else> <span class="sm">Gerekli Komisyon</span> 0 TL </span>
          </div>
          <div class="accordion-wrapper__row__cell">
            <span v-if="items.fundAmount != 0">
              <span class="sm">Gerekli Fon / Bes Büyüklüğü</span>
              {{ formatPriceNoDecimal(items.calculatedFundAmount) }}
              TL
            </span>
            <span v-else>
              <span class="sm">Gerekli Fon / Bes Büyüklüğü</span> 0 TL
            </span>
          </div>
        </div>
        <base-icon
          class="loader-icon"
          name="loader"
          v-if="isLoading"
        ></base-icon>
      </div>
    </div>
  </div>
</template>

<script>
import { BaseIcon } from "@/components";
import { mapActions } from "vuex";
import mixins from "../../mixins";

export default {
  name: "ScreenPrices",
  components: {
    BaseIcon,
  },
  mixins: [mixins],
  props: {
    screenPriceList: Array,
    featureScreenPricesList: Array,
    isMobile: Boolean,
  },
  data() {
    return {
      isLoading: false,
      activeIndex: null,
      localFeatureScreenPricesList: this.featureScreenPricesList,
    };
  },
  computed: {
    sortedScreenPriceList: function () {
      const sortedList = [...this.screenPriceList];

      sortedList.sort((a, b) => a.order - b.order);
      return sortedList;
    },
  },
  methods: {
    ...mapActions(["getScreenPrices", "getFeatureScreenPrices"]),
    toggleAccordion(applicationId, platformId, researchId, index) {
      this.activeIndex = this.activeIndex === index ? null : index;

      const args = {
        applicationId: applicationId != null ? applicationId : 0,
        platformId: platformId != null ? platformId : 0,
        researchId: researchId != null ? researchId : 0,
      };
      this.localFeatureScreenPricesList = [];
      if (this.activeIndex == index) {
        this.getScreenPrices(args).then((res) => {
          this.$nextTick(() => {
            //Osmanlı Pro Matriks Masaüstü için burada çıkartıldı !!!! Tekrar eklemek istenirse bu filter'ı tamamen sil.
            if (
              platformId == this.Products.type.Desktop &&
              applicationId == this.Products.name.Matriks
            ) {
              res = res.filter(
                (item) =>
                  !item.research?.name?.toLowerCase().includes("osmanlı")
              );
            }
            if (
              platformId === this.Products.type.Mobile &&
              (applicationId === this.Products.name.Matriks ||
                applicationId === this.Products.name.MatriksIQ)
            ) {
              res = res.filter(
                (item) =>
                  !item.research?.name?.toLowerCase().includes("stockkeys")
              );
            }
            // Yukarıdaki yapı tamamen Osmanlı Pro ürününün hukuki sürecini korumak için yazılmıştır. Geri alınması istenirse yukarıdaki tüm koşullar silinmelidir.
            // Yukarıdaki kod stockkeys ve osmanlı ürünlerini Mobil ve Desktop olarak kontrol ederek işlemektedir.
            const screenPrice = res.filter((x) => x.featureType == 2);
            const withoutScreenPrice = res.filter((x) => x.featureType != 2);

            let processedItems = withoutScreenPrice.map((item) => {
              const shouldAddScreenFund =
                item.featureType === 3 || item.featureType === 4;

              const extraFund =
                shouldAddScreenFund && screenPrice[0]
                  ? screenPrice[0].fundAmount
                  : 0;

              const extraCommission =
                shouldAddScreenFund && screenPrice[0]
                  ? screenPrice[0].commissionAmount
                  : 0;

              if (item.market?.name === "Osmanlı Pro") {
                item = {
                  ...item,
                  market: {
                    ...item.market,
                    name: "Osmanlı Pro - ",
                  },
                };
              }

              return {
                ...item,
                calculatedFundAmount: item.fundAmount + extraFund,
                calculatedCommissionAmount:
                  item.commissionAmount + extraCommission,
              };
            });

            const osmanliIndex = processedItems.findIndex(
              (item) => item.market?.name === "Osmanlı Pro - "
            );
            const stockkeysIndex = processedItems.findIndex(
              (item) => item.market?.name === "Prime"
            );
            const mkkIndex = processedItems.findIndex(
              (item) => item.market?.name === "MKK Verileri"
            );
            const [osmanliItem] = processedItems.splice(osmanliIndex, 1);
            let insertIndex;

            if (stockkeysIndex !== -1 && mkkIndex !== -1) {
              insertIndex = Math.min(stockkeysIndex, mkkIndex);
            } else if (stockkeysIndex !== -1) {
              insertIndex = stockkeysIndex;
            } else if (mkkIndex !== -1) {
              insertIndex = mkkIndex;
            } else {
              insertIndex = processedItems.length;
            }

            processedItems.splice(insertIndex, 0, osmanliItem);

            this.localFeatureScreenPricesList = processedItems;
            this.newScreenPrice = screenPrice;
          });
        });
      }
    },
    splitVendorNames(vendorName) {
      let takeSlash =
        String(vendorName).indexOf("(") > -1
          ? String(vendorName).split("(")[1]
          : "";
      let takeBetwwenSlashes = takeSlash.split(")")[0];
      let mergeVendorNames = null;

      if (takeSlash.indexOf("AKDE") > -1) {
        mergeVendorNames = " Aracı Kurum Dağılımı Eşanlı";
      } else if (takeSlash.indexOf("AKD") > -1) {
        mergeVendorNames = " Aracı Kurum Dağılımı Günsonu";
      } else if (takeBetwwenSlashes.indexOf("VAKD") > -1) {
        mergeVendorNames = " Aracı Kurum Dağılımı Günsonu";
      } else {
        mergeVendorNames = vendorName;
      }
      return mergeVendorNames;
    },
    returnPriceTypeForScreenPrices(priceTypeNumber) {
      if (priceTypeNumber == 1) {
        return "TL";
      } else if (priceTypeNumber == 2) {
        return "USD";
      } else if (priceTypeNumber == 3) {
        return "EUR";
      }
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.accordion-wrapper {
  position: relative;
  display: table;
  width: 100%;
  border: 1px solid var(--color-primary-tint-second);
  margin-bottom: 21px;
  border-radius: var(--radius-first);
  background-color: var(--grayscale-0);
  cursor: pointer;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }

  &__row,
  &__row__cell {
    padding: 13px 20px;
  }

  &__row {
    display: table-row;
    @media (max-width: 768px) {
      display: flex;
      flex-direction: column;
      padding: 0px;
    }
    &:nth-child(2n) {
      @media (min-width: 768px) {
        background: var(--color-primary-zebra);
      }
    }
    &.caption {
      display: table-row-group;
      background-color: var(--color-primary-tint);
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;

      @media screen and (max-width: 768px) {
        position: sticky;
        top: 0px;
        padding: 12px;
        span {
          font-weight: 600;
        }
      }
    }
    &:not(.caption) {
      @media (max-width: 768px) {
        margin-bottom: 16px;
        &:last-child {
          margin-bottom: 0px;
        }
      }
      .accordion-wrapper__row__cell {
        border-bottom: 1px solid var(--color-primary-tint-second);
        @media (max-width: 768px) {
          &:first-child {
            border-top: 1px solid var(--color-primary-tint-second);
            display: inline-flex;
          }
        }
        font-size: 12px;
        font-weight: 500;
      }
    }
    &__cell {
      display: table-cell;
      box-sizing: border-box;
      vertical-align: middle;
      color: var(--color-primary-black-metallic);
      .sm {
        display: none;
        font-weight: 500;
      }
      @media (max-width: 768px) {
        &:nth-child(2n) {
          background: var(--color-primary-zebra);
        }
        width: 100%;
        &.mh {
          display: none;
        }
        .sm {
          display: block;
          font-weight: 600;
        }
        span {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          font-size: 12px;
          font-weight: 400;
          &.inner-texts {
            font-weight: 600;
          }
          span:not(.inner-texts) {
            font-weight: 600;
          }
        }
      }
      &:first-child {
        min-width: 350px;
        white-space: nowrap;
        @media (max-width: 520px) {
          min-width: auto;
          white-space: normal;
          padding-right: 30px;
        }
      }
      @media (min-width: 768px) {
        &:nth-child(2) {
          min-width: 100px;
          text-align: right;
        }
        &:nth-child(3) {
          width: 165px;
        }
        &:nth-child(4) {
          width: 250px;
        }
        &:nth-child(3),
        &:nth-child(4),
        &:nth-child(5) {
          text-align: right;
        }
        &:last-child {
          padding-right: 50px;
        }
      }

      &.hidden {
        display: none;
      }
      .inner-texts {
        display: inline-block;
        padding-right: 10px;
        @media (max-width: 768px) {
          padding: 0px;
        }
        &.index {
          min-width: 25px;
          font-weight: 700;
          @media (max-width: 768px) {
            min-width: 20px;
          }
        }
        &:last-child {
          padding-right: 0px;
        }
      }
    }
  }

  &.active {
    background: transparent;
    .accordion-content {
      display: table-row-group;
    }
  }

  .accordion-title-wrapper {
    display: table-row;
    position: relative;
    @media (max-width: 768px) {
      display: flex;
    }
    &.active {
      .hidden {
        background-color: var(--color-primary-tint);
      }
    }
    .accordion-wrapper__row__cell {
      visibility: visible;
      padding-top: 9.5px;
      padding-bottom: 9.5px;
      &:first-child {
        font-size: 14px;
        font-weight: bold;
        @media (max-width: 768px) {
          padding: 0px;
          padding-right: 30px;
        }
      }
      &:nth-child(4) {
        padding-right: 50px;
      }
    }
  }
  .collapse-icon {
    position: absolute;
    top: 50%;
    transform: rotate(180deg) translateY(50%);
    right: 10px;
    @media (max-width: 768px) {
      right: 0px;
    }
    &.active {
      transform: rotate(0deg);
      top: 8px;
      right: 10px;
      @media (max-width: 768px) {
        top: -4px;
      }
    }
  }
  .accordion-content {
    display: table-row-group;
  }
}
</style>
